import { $, $$ } from "../base-styles";

export const $grid = $$("div.clearfix");
